import PageHeader from '../components/PageHeader';
import Contact from '../components/Contact';
import { ContactInfoCards } from '../components/contact/ContactInfoCards';
import { ContactMap } from '../components/contact/ContactMap';
import { useSeo } from '../hooks/useSeo';

export default function ContactPage() {
  useSeo({
    title: 'Iletisim',
    description: 'Membratek ile iletisime gecin. Gaziantep merkezli ofisimiz, telefon ve e-posta bilgileri. Ucretsiz proje danismanligi ve fiyat teklifi.',
    path: '/iletisim',
  });
  return (
    <main>
      <PageHeader eyebrow="ILETISIM" title="Bize Ulasin" description="Size en uygun cozumu sunmak icin bizimle iletisime gecin. Ekibimiz 24 saat icinde sizinle iletisime gececektir." />
      <ContactInfoCards />
      <Contact />
      <ContactMap />
    </main>
  );
}